import { normalizarStatusRecurso, RECURSO_STATUS } from '@/utils/recursosConstants';
import { normalizarDocumento } from '@/utils/documento';

const PENDENTE_RESPOSTA = ['CRIADO', 'CRIADA'];

const SITUACOES = {
  CRIADO: { label: 'Criado', type: 'is-info' },
  CRIADA: { label: 'Criada', type: 'is-info' },
  RESPONDIDO: { label: 'Respondido', type: 'is-success' },
  DEFERIDA: { label: 'Deferida', type: 'is-success' },
  INDEFERIDA: { label: 'Indeferida', type: 'is-danger' },
  ADMISSIVEL: { label: 'Admissível', type: 'is-success' },
  INADMISSIVEL: { label: 'Inadmissível', type: 'is-danger' },
  [RECURSO_STATUS.DEFERIDO]: { label: 'Deferido', type: 'is-success' },
  [RECURSO_STATUS.INDEFERIDO]: { label: 'Em Análise', type: 'is-info' },
};

export function manifestacaoPertenceEmpresa(manifestacao, company) {
  if (!manifestacao || !company) return false;

  if (manifestacao.empresaId != null && company.id != null) {
    return manifestacao.empresaId === company.id;
  }

  const autor = manifestacao.question || manifestacao.recurso;
  if (!autor) return false;

  // CNPJ alfanumérico: comparamos a string normalizada completa (letras
  // incluídas), não só os dígitos — descartar as letras poderia fazer dois
  // CNPJs alfanuméricos diferentes, mas com a mesma sequência de dígitos,
  // serem tratados como a mesma empresa (falso positivo de autorização).
  const cnpjAutor = normalizarDocumento(autor.cnpj);
  const cnpjEmpresa = normalizarDocumento(company.cnpj);
  if (cnpjAutor && cnpjEmpresa) {
    return cnpjAutor === cnpjEmpresa;
  }

  const emailAutor = String(autor.email || '')
    .trim()
    .toLowerCase();
  const emailEmpresa = String(company.email || '')
    .trim()
    .toLowerCase();

  return !!(emailAutor && emailEmpresa && emailAutor === emailEmpresa);
}

function exibirComoNaoRespondido(status, { paraLicitante, manifestacaoPropria }) {
  const chave = String(status || '').toUpperCase();

  if (!PENDENTE_RESPOSTA.includes(chave)) {
    return false;
  }

  return !paraLicitante || !manifestacaoPropria;
}

function recursoSituacaoExibicao(status, { janelaRecursal, papel }) {
  const chave = normalizarStatusRecurso(status);

  if (chave === RECURSO_STATUS.DEFERIDO) {
    return { label: 'Deferido', type: 'is-success' };
  }

  if (chave === RECURSO_STATUS.INDEFERIDO) {
    return {
      label: 'Em Análise',
      type: papel === 'autoridade' ? 'is-warning' : 'is-info',
    };
  }

  if (chave === RECURSO_STATUS.ADMISSIVEL) {
    return { label: 'Admitido', type: 'is-success' };
  }

  if (chave === RECURSO_STATUS.INADMISSIVEL) {
    return { label: 'Inadmitido', type: 'is-danger' };
  }

  if (chave === RECURSO_STATUS.CRIADO) {
    if (janelaRecursal === 'razoes' || janelaRecursal === 'contrarrazoes') {
      return { label: 'Enviado', type: 'is-info' };
    }

    return {
      label: 'Em Consideração',
      type: papel === 'pregoeiro' ? 'is-warning' : 'is-info',
    };
  }

  return null;
}

export function manifestacaoSituacaoLabel(
  status,
  {
    paraLicitante = false,
    manifestacaoPropria = false,
    fluxo = '',
    janelaRecursal = null,
    papel = 'licitante',
  } = {},
) {
  const chave = normalizarStatusRecurso(status);

  if (fluxo === 'recurso') {
    const exibicao = recursoSituacaoExibicao(chave, { janelaRecursal, papel });
    if (exibicao) {
      return exibicao.label;
    }
  }

  if (exibirComoNaoRespondido(status, { paraLicitante, manifestacaoPropria })) {
    return chave === 'CRIADA' ? 'Não Respondida' : 'Não Respondido';
  }

  const situacao = SITUACOES[chave];

  if (situacao) {
    return situacao.label;
  }

  if (!chave) return '';

  return `${chave.charAt(0).toUpperCase()}${chave.slice(1).toLowerCase()}`;
}

export function manifestacaoSituacaoTipo(
  status,
  {
    paraLicitante = false,
    manifestacaoPropria = false,
    fluxo = '',
    janelaRecursal = null,
    papel = 'licitante',
  } = {},
) {
  const chave = normalizarStatusRecurso(status);

  if (fluxo === 'recurso') {
    const exibicao = recursoSituacaoExibicao(chave, { janelaRecursal, papel });
    if (exibicao) {
      return exibicao.type;
    }
  }

  if (exibirComoNaoRespondido(status, { paraLicitante, manifestacaoPropria })) {
    return 'is-warning';
  }

  return SITUACOES[chave]?.type || 'is-light';
}
